'use client';

import PiwikProProvider, { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const Piwik = ({ children, nonce }: { children: React.ReactNode; nonce?: string }) => {
  const PIWIK_ID =
    process.env.NODE_ENV === 'production'
      ? 'ccf38a55-28b8-456f-a8e0-e6616d55adf0'
      : '776423a5-57f5-4123-b48a-7fc59a8905e4';
  const piwikUrl = `https://booli.containers.piwik.pro`;

  const { PageViews } = usePiwikPro();
  const pathname = usePathname();

  useEffect(() => {
    const title = pathname || 'unknown';

    PageViews.trackPageView(title);
  }, [pathname, PageViews]);

  return (
    <PiwikProProvider
      containerUrl={piwikUrl}
      containerId={PIWIK_ID}
      nonce={nonce}
    >
      {children}
    </PiwikProProvider>
  );
};

export { Piwik };
